<template>
  <div>
    <div @click="openAddessForm" style="height:175px;display:table;width:100%;" v-if="!showAddressForm">
      <el-card class="dotted-card" :shadow="'never'" style="height:175px;text-align: center;display:table-cell;vertical-align: middle;">
        {{$t('common.addresses.AddNewAddress')}}
      </el-card>
    </div>
    <div style="border:1px solid #DCDFE6; padding:5px;" v-if="showAddressForm">
      <AddressForm :show="showAddressForm" @add="addAddress" @cancel="cancel"></AddressForm>
    </div>
  </div>
</template>

<script>

import AddressForm from '@/components/address/Address-Form'

export default {
	name: 'AddressFlatEditor',
	props: {

	},
	data() {
		return {
      showAddressForm : false
		}
	},
	components : {
    AddressForm
  },
	methods : {
    openAddessForm(){
      this.$emit('clickToAdd');
      this.showAddressForm=true;
    },
    cancel(){
      this.$emit('cancel');
      this.closeAddressForm();
    },
    addAddress(address){
      this.$emit('add',address);
      this.closeAddressForm();
    },
    editAddress(){
      this.closeAddressForm();
      this.$emit('change',this.currentAddress);
    },
    closeAddressForm(){
      this.showAddressForm = false;
    },
	}
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables';




</style>
